import {
  AnalyticsConfiguration,
  DEFAULT_ANALYTICS_CONFIGURATION,
  DigitalTouchPointConfig,
} from '@refx/analytics-core';

/**
 * Get analytics configuration
 */
export function getAnalyticsConfiguration(): AnalyticsConfiguration {
  return {
    ...DEFAULT_ANALYTICS_CONFIGURATION,
    activateDigitalAnalyticsLayer: false
  };
}

/**
 * Get digital touch point data
 *
 * @returns DigitalTouchPointConfig
 */
export function getDigitalTouchpointData(): DigitalTouchPointConfig {
  return {};
}
